import { Injectable } from '@angular/core';
import { OidcSecurityCommon } from './oidc.security.common';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
export class OidcSecuritySilentRenew {
private sessionIframe: any;
/**
 * @param {?} oidcSecurityCommon
 */
constructor(private oidcSecurityCommon: OidcSecurityCommon) {
    }
/**
 * @return {?}
 */
initRenew() {
        this.sessionIframe = window.document.createElement('iframe');
        this.oidcSecurityCommon.logDebug(this.sessionIframe);
        this.sessionIframe.style.display = 'none';

        window.document.body.appendChild(this.sessionIframe);
    }
/**
 * @param {?} url
 * @return {?}
 */
startRenew(url: string) {
        this.oidcSecurityCommon.logDebug('startRenew for URL:' + url);
        this.sessionIframe.src = url;

        return Observable.create((observer: Observer<any>) => {
            this.sessionIframe.onload = () => {
                observer.next(this);
                observer.complete();
            }
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OidcSecurityCommon, },
];
}

function OidcSecuritySilentRenew_tsickle_Closure_declarations() {
/** @type {?} */
OidcSecuritySilentRenew.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OidcSecuritySilentRenew.ctorParameters;
/** @type {?} */
OidcSecuritySilentRenew.prototype.sessionIframe;
/** @type {?} */
OidcSecuritySilentRenew.prototype.oidcSecurityCommon;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
